/* DURA landing sections – shared behaviour (no dependencies) */
(function () {
  if (window.__duraLanding) { window.__duraLanding.initAll(document); return; }

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- Pause / play for background videos ---- */
  function initPause(root) {
    root.querySelectorAll('[data-dura-pause]').forEach(function (btn) {
      if (btn.__dura) return; btn.__dura = true;
      var scope = btn.closest('.dura');
      var video = scope && scope.querySelector('video');
      if (!video) { btn.hidden = true; return; }
      if (reduceMotion) { video.pause(); btn.classList.add('is-paused'); }
      btn.addEventListener('click', function () {
        if (video.paused) { video.play(); btn.classList.remove('is-paused'); btn.setAttribute('aria-label', btn.dataset.labelPause || 'Pause'); }
        else { video.pause(); btn.classList.add('is-paused'); btn.setAttribute('aria-label', btn.dataset.labelPlay || 'Play'); }
      });
    });
  }

  /* ---- Inline video player (play + mute) ---- */
  function initVideo(root) {
    root.querySelectorAll('[data-dura-video]').forEach(function (wrap) {
      if (wrap.__dura) return; wrap.__dura = true;
      var video = wrap.querySelector('video');
      var play = wrap.querySelector('[data-dura-play]');
      var mute = wrap.querySelector('[data-dura-mute]');
      if (!video) { if (play) play.parentNode.hidden = true; return; }
      if (reduceMotion && video.autoplay) video.pause();
      if (play && (video.paused || !video.autoplay)) play.classList.add('is-paused');
      if (play) play.addEventListener('click', function () {
        if (video.paused) { video.play(); play.classList.remove('is-paused'); } else { video.pause(); play.classList.add('is-paused'); }
      });
      if (mute) mute.addEventListener('click', function () {
        video.muted = !video.muted; mute.classList.toggle('is-unmuted', !video.muted);
      });
    });
  }

  /* ---- Switcher: tabs, lists and accordions that show one item at a time ---- */
  function initSwitch(root) {
    root.querySelectorAll('[data-dura-switch]').forEach(function (box) {
      if (box.__dura) return; box.__dura = true;
      var triggers = box.querySelectorAll('[data-switch-trigger]');
      var targets = box.querySelectorAll('[data-switch-target]');
      var count = 0; triggers.forEach(function (t) { count = Math.max(count, +t.dataset.switchTrigger + 1); });
      var current = 0, timer = null;
      var interval = +box.dataset.autoplay || 0;

      function show(i, fromUser) {
        current = i;
        triggers.forEach(function (t) {
          var on = +t.dataset.switchTrigger === i;
          t.classList.toggle('is-active', on);
          if (t.getAttribute('role') === 'tab') t.setAttribute('aria-selected', on ? 'true' : 'false');
          if (t.hasAttribute('aria-expanded')) t.setAttribute('aria-expanded', on ? 'true' : 'false');
        });
        targets.forEach(function (t) { t.classList.toggle('is-active', +t.dataset.switchTarget === i); });
        if (fromUser) stop();
      }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }
      function start() {
        if (!interval || reduceMotion || timer || count < 2) return;
        timer = setInterval(function () { show((current + 1) % count); }, interval);
      }

      triggers.forEach(function (t) {
        t.addEventListener('click', function () { show(+t.dataset.switchTrigger, true); });
        if (box.dataset.hover !== undefined) t.addEventListener('mouseenter', function () { show(+t.dataset.switchTrigger, true); });
      });
      box.addEventListener('keydown', function (e) {
        if (!e.target.matches('[role="tab"]')) return;
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        var n = (current + (e.key === 'ArrowRight' ? 1 : count - 1)) % count;
        show(n, true);
        var next = box.querySelector('[data-switch-trigger="' + n + '"][role="tab"]'); if (next) next.focus();
      });

      if ('IntersectionObserver' in window && interval) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (en) { en.isIntersecting ? start() : stop(); });
        }, { threshold: .3 }).observe(box);
      }
      box.__duraShow = function (i) { show(i, true); };
      show(Math.min(+box.dataset.start || 0, Math.max(count - 1, 0)));
    });
  }

  /* ---- Snap track: carousel with arrows, active slide and dots ---- */
  function initTrack(root) {
    root.querySelectorAll('[data-dura-track]').forEach(function (track) {
      if (track.__dura) return; track.__dura = true;
      var slides = Array.prototype.slice.call(track.children);
      var scope = track.closest('[data-dura-track-scope]') || track.parentNode;
      var dots = scope.querySelectorAll('[data-dura-dots] span');
      var active = 0;

      function setActive(i) {
        active = i;
        slides.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
        dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
      }
      function go(i) {
        i = Math.max(0, Math.min(slides.length - 1, i));
        var s = slides[i];
        track.scrollTo({ left: s.offsetLeft - (track.clientWidth - s.clientWidth) / 2, behavior: reduceMotion ? 'auto' : 'smooth' });
      }
      function nearest() {
        var mid = track.scrollLeft + track.clientWidth / 2, best = 0, dist = Infinity;
        slides.forEach(function (s, k) {
          var d = Math.abs(s.offsetLeft + s.clientWidth / 2 - mid);
          if (d < dist) { dist = d; best = k; }
        });
        return best;
      }
      var raf;
      track.addEventListener('scroll', function () {
        cancelAnimationFrame(raf); raf = requestAnimationFrame(function () { var n = nearest(); if (n !== active) setActive(n); });
      }, { passive: true });
      slides.forEach(function (s, k) { s.addEventListener('click', function () { if (k !== active) go(k); }); });
      var prev = scope.querySelector('[data-dura-prev]'), next = scope.querySelector('[data-dura-next]');
      if (prev) prev.addEventListener('click', function () { go(active - 1); });
      if (next) next.addEventListener('click', function () { go(active + 1); });
      track.__duraGo = go;

      var start = Math.min(+track.dataset.start || 0, slides.length - 1);
      setActive(start);
      requestAnimationFrame(function () {
        var s = slides[start]; if (s) track.scrollLeft = s.offsetLeft - (track.clientWidth - s.clientWidth) / 2;
      });
    });
  }

  function initAll(root) { initPause(root); initVideo(root); initSwitch(root); initTrack(root); }

  /* Theme editor: re-init a reloaded section and jump to a selected block */
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var el = e.target, idx = el.dataset && el.dataset.duraIndex;
    if (idx === undefined) return;
    var box = el.closest('[data-dura-switch]'); if (box && box.__duraShow) box.__duraShow(+idx);
    var track = el.closest('[data-dura-track]'); if (track && track.__duraGo) track.__duraGo(+idx);
  });

  window.__duraLanding = { initAll: initAll };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  else initAll(document);
})();